<template>
  <div class="self_table">
    <el-table :data="tableData" ref="table" :style="{ width: '100%', overflow: 'auto', }" v-loading="loading"
      :row-key="(row) => row.folderId" @row-click="handleRowClick" :stripe="false"
      @selection-change="handleSelectionChange" :header-cell-style="{
        color: '#25345A',
        fontSize: '14px',
        textAlign: 'left',
      }" :cell-style="{
        textAlign: 'left',
      }" :height="tableHeight">
      <template slot="empty">
        <div class="no_data_area">
          <div class="no_data"></div>
          <div class="no_staff">
            <span>暂无相关数据</span>
          </div>
        </div>
      </template>
      <el-table-column type="selection" width="55" v-if="selecttype"></el-table-column>
      <template v-for="(item, index) in columns">
        <el-table-column :prop="item.prop" :label="item.label" :width="item.width" :min-width="item.minWidth"
          :show-overflow-tooltip="showoverflowtooltip" :sortable="item.sortable" :fixed="item.fixed">
          <template slot-scope="scope">
            <template v-if="item.prop == 'folderName'">
              <div style="display: flex;justify-content: space-between;padding-right: 30px;">
                <div class="display_flex_center" style="height: 50px;width: 50%;" @click.stop="lookfile(scope.row)">
                  <div style="position: relative;">
                    <Fileicon :fileNameURl="scope.row['fpath']" :fileSmallPath="scope.row['fileSmallPath']" :filetype="scope.row['type']"></Fileicon>
                    <template v-if="isnew">
                      <div class="newfload" v-if="scope.row['type'] == 1 && time(scope.row['updateDate'], true) > 0">
                      </div>
                    </template>
                  </div>
                  <div class="text-ellipsis" style="margin-left: 10px;">{{ scope.row["folderName"] }}</div>
                </div>
                <div class="display_flex_center icon_list" v-if="btntype == 1">
                  <span class="icon_list_show">
                    <el-button type="text" @click.stop="btnlist(0, scope.row)" style="padding:0 10px;" v-if="fxtype">
                      <i class="iconfont icon-fenxiang1" style=" color: #4E66FF;"></i>
                    </el-button>
                    <el-button type="text" @click.stop="btnlist(1, scope.row)" style="padding:0 10px;">
                      <i class="iconfont icon-xiazai1" style=" color: #4E66FF;"></i>
                    </el-button>
                    <el-button type="text" @click.stop="btnlist(2, scope.row)" style="padding:0 10px;" v-if="sctype">
                      <i class="iconfont icon-shoucang" style=" color: #4E66FF;"></i>
                    </el-button>
                    <el-button type="text" @click.stop="btnlist(3, scope.row)" style="padding:0 10px;" v-if="deltype">
                      <i class="iconfont icon-shanchu1" style=" color: #4E66FF;"></i>
                    </el-button>
                  </span>
                </div>
                <!-- 0复制链接    1取消分享 -->
                <div class="display_flex_center icon_list" v-if="btntype == 2">
                  <span class="icon_list_show" v-if="fxtypetwo">
                    <el-button type="text" @click.stop="btnlist(0, scope.row)" style="padding: 0 10px;">
                      <i class="iconfont icon-fuzhilianjie" style=" color: #4E66FF;"></i>
                    </el-button>
                    <el-button type="text" @click.stop="btnlist(1, scope.row)" style="padding: 0 10px;">
                      <i class="iconfont icon-shanchu1" style=" color: #4E66FF;"></i>
                    </el-button>
                  </span>
                  <span class="icon_list_show" v-else>
                    <el-button type="text" @click.stop="btnlist(2, scope.row)" style="padding: 0 10px;">
                      <i class="iconfont icon-fenxiang1" style=" color: #4E66FF;"></i>
                    </el-button>
                    <el-button type="text" @click.stop="btnlist(3, scope.row)" style="padding: 0 10px;">
                      <i class="iconfont icon-xiazai1" style=" color: #4E66FF;"></i>
                    </el-button>
                  </span>
                </div>
              </div>
            </template>

            <template v-else-if="scope.row['isOpen'] && item.prop == 'isOpen'">
              <span>{{ scope.row['isOpen'] == 1 ? "生效中" : "已失效" }}</span>
            </template>


            <template v-else-if="item.prop == 'sharePhoneNum'">
              <span>{{ scope.row['sharePhoneNum'] ? '私密分享' : '普通分享' }}</span>
            </template>

            <template v-else>
              <div>
                {{ scope.row[item.prop] != null ? scope.row[item.prop] : "" }}
              </div>
            </template>
          </template>
        </el-table-column>
      </template>

      <el-table-column label="操作" :width="btnlong" v-if="showbtn">
        <template slot-scope="scope">
          <slot name="header" v-bind:date="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <!-- 是否调用分页 -->
    <div class="com_page" v-if="pageObj && pageObj.total">
      <el-pagination layout="total, prev, pager, next, jumper" :page-size="pageObj.size" :total="pageObj.total"
        :current-page="pageObj.page" @current-change="handleCurrentChange" background row-key="id">
      </el-pagination>
    </div>

     <!-- 视频 -->
    <el-dialog title="" :close-on-press-escape="true" :close-on-click-modal="true" :visible.sync="videoshow"
      :show-close="false" :fullscreen="true" :custom-class="'videoandimg'">
      <template #title>
        <div style="display: flex;justify-content: space-between;">
          <div></div>
          <i class="el-icon-error" style="font-size: 22px;color: #c8c9cc;cursor: pointer;" @click="closevideo"></i>
        </div>
      </template>
      <div style="width: 70%;position: absolute;left: 50%;transform: translateX(-50%);">
        <videoPlayer ref="videoPlayer" class="video-player vjs-big-play-centered" :playsinline="false"
          :options="playOptions" />
        <div style="text-align: center;color: #fff;width: 100%;font-size: 18px;margin-top: 50px;">
          {{ videotext }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>




    <!-- 图片 -->
    <el-dialog title="" :close-on-press-escape="true" :close-on-click-modal="true" :visible.sync="imgshow"
      :show-close="false" :fullscreen="true" :custom-class="'videoandimg'">
      <template #title>
        <div style="display: flex;justify-content: space-between;">
          <div></div>
          <i class="el-icon-error" style="font-size: 22px;color: #c8c9cc;cursor: pointer;" @click="closeimgshow"></i>
        </div>
      </template>
      <div style="width: 70%;position: absolute;left: 50%;transform: translateX(-50%);">
        <el-carousel trigger="click" height="150px" :autoplay="false" :initial-index="imgindex" @change="selectimg">
          <el-carousel-item v-for="(it, id) in imglist" :key="id">
            <img :src="it.url" alt="" style="width: auto;height: auto;">
          </el-carousel-item>
        </el-carousel>
        <div style="text-align: center;color: #fff;width: 100%;font-size: 18px;margin-top: 50px;">
          {{ videotext }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>
  </div>
</template>

<script>
import "video.js/dist/video-js.css"
import { videoPlayer } from "vue-video-player"
export default {
  components: { videoPlayer },
  props: {
    //   表头
    columns: {
      type: Array,
      default: () => [],
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => [],
    },
    // 当前选中的数据
    selectionlist: {
      type: Array,
      default: () => [],
    },
    // 加载展示
    loading: {
      type: Boolean,
      default: false,
    },
    // 分页
    pageObj: {
      type: Object,
      default: function () {
        return {
          pageSize: 10,
          total: 0,
          page: 1,
        }
      },
    },
    // 按钮长度
    btnlong: {
      type: String,
      default: "",
    },
    // 按钮是否显示
    showbtn: {
      type: Boolean,
      default: () => false,
    },
    showoverflowtooltip: {
      type: Boolean,
      default: () => true,
    },
    Height: {
      type: Number,
      default: 200,
    },
    btntype: {
      type: Number,
      default: 1,
    },
    selecttype: {
      type: Boolean,
      default: () => true,
    },
    deltype: {
      type: Boolean,
      default: () => false,
    },
    sctype: {
      type: Boolean,
      default: () => false,
    },
    fxtype: {
      type: Boolean,
      default: () => false,
    },
    fxtypetwo: {
      type: Boolean,
      default: () => true,
    },
    isnew: {
      type: Boolean,
      default: () => true,
    },
  },
  watch: {
    selectionlist: {
      handler(newVal, oldVal) {
        this.selectionlists = newVal
      }
    },
  },
  data() {
    return {
      tableHeight: 0,
      selectionlists: this.selectionlist,
      // 视频
      playOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: true, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", // url地址
          },
        ],
        poster: "", // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          // 当前时间和持续时间的分隔符
          timeDivider: true,
          // 显示持续时间
          durationDisplay: true,
          // 是否显示剩余时间功能
          remainingTimeDisplay: true,
          // 是否显示全屏按钮
          fullscreenToggle: true,
        },
      },
      videotext: '',
      videoshow: false,
      // 图片
      imgshow: false,
      imgindex: 0,
      imglist: []
    }
  },
  computed: {

  },
  created() {
    // 100是表格外其它布局占的高度，这个数值根据自己实际情况修改
    this.tableHeight = window.innerHeight - this.Height
  },
  mounted() {
    const _this = this
    // _this.selectData()
    // 设置表格高度
    this.tableHeight = window.innerHeight - this.Height
    // / 监听浏览器窗口变化，动态计算表格高度，
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - this.Height
      })()
    }
  },
  methods: {
    handleCurrentChange(val) {
      const _this = this
      this.$emit("handleCurrentChange", val)
    },

    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val)
    },

     // 选择左右
    selectimg(index) {
      console.log(index)
      this.imglist.forEach((it,id) => { 
        if (id == index) { 
          this.videotext = it.fname
          this.imgindex = index
        }
      })
    },
    // 查看
    lookfile(row) {
      if (row.fpath && row.fpath != '') {
        let arrimg = ["jpeg", "dib", "gif", "jfif", "jpe", "jpeg",
          "jpg", "JPG", "png", "tif", "tiff", "bmp", "webp", "ico"]
        let arrvideo = ["mp4", "MP4", "mov"
          , "mkv", "avi", "mov", "flv", "wmv", "webm", "3gp", "mpeg", "mpg", "m4v"
          , "f4v", "rm", "rmvb", "ts", "m2ts", "ogv", "divx", "xvid", "vob"]
        let typefile = this.filename(row.fpath)
        let img = arrimg.some(it => it == typefile)
        let video = arrvideo.some(it => it == typefile)
        console.log(img, video,123)
        if (img) {
          this.imglist = []
          this.videotext = ''
          this.imgindex = 0
          this.imgshow = true
          this.tableData.forEach((it, id) => {
            if (arrimg.some(i => i == this.filename(it.fpath))) {
              if (it.fileSmallPath) {
                this.imglist.push({
                  url: this.$lookfile + '/big/' + it.fileSmallPath,
                  fpath: it.fpath,
                  fname: it.fname,
                })
              } else { 
                this.imglist.push({
                  url: this.$lookfile + '/big/' + it.fpath,
                  fpath: it.fpath,
                  fname: it.fname,
                })
              }
            }
          })
          this.imglist.forEach((it, id) => { 
            if (it.fpath == row.fpath) {
                this.videotext = row.fname
                this.imgindex = id
            }
          })
        } else if (video) {
          this.dialog({
            title: row.folderName,
            oss_file: this.$lookfile + '/file/' + row.fpath
          })
          this.videoshow = true
        } else {
          this.$emit('dowonloadonly', row)
        }
      } else {
        this.$emit('rowchang', row)
      }
    },
    // 关闭图片
    closeimgshow() { 
      this.imgshow = false
      this.imglist = []
      this.videotext = ''
      this.imgindex = 0
    },
    handleRowClick(row) {
      this.$emit('rowchang', row)
    },
    btnlist(type, obj) {
      this.$emit("btnlist", type, obj)
    },
    // 打开视频
    dialog(val) {
      this.videotext = val.title
      this.videoshow = true
      this.playOptions.sources[0].src = val.oss_file
    },
    //关闭视频
    closevideo() {
      this.videoshow = false
      this.$refs.videoPlayer.player.muted(true)
    },
  },
}
</script>

<style lang='less'>


.newfload {
  position: absolute;
  top: 0;
  right: 0;
  background-image: url('./new.png');
  width: 25px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
}


.el-table tr {
  cursor: pointer;
}

.el-checkbox__input.is-disabled .el-checkbox__inner {
  background-color: #ccc;
  border-color: #ccc;
}

.el-image-viewer__actions {
  overflow: hidden;
}

.el-image-viewer__btn {
  overflow: hidden;
  display: block;
  text-align: center;
}

.el-tooltip__popper {
  font-size: 14px;
  max-width: 50%;
  padding-bottom: 5px !important;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.el-tooltip__popper,
.el-tooltip__popper.is-dark {
  background: rgb(0, 0, 0) !important;
  color: #fff !important;
  line-height: 24px;
}
</style>

<style lang='less' scoped>
/deep/ .el-dialog__wrapper{
  background: #000;
}


.dialog_btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  background: #000;
  color: #fff;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
  cursor: pointer;
}



/deep/ .el-dialog__header {
  overflow: hidden;
}

/deep/ .el-dialog {
  border-radius: 0 !important;
  background: inherit;
  box-shadow: none;
  width: 100%;
}

.icon_list_show {
  display: none;
}

// < !-- 鼠标移入需要改变样式的单元格时，该单元格改变样式 -->
.el-table .cell:hover {
  .icon_list_show {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #4E66FF;
  }
}

// < !-- 鼠标移入本行中任意一个元素，该单元格改变样式 -->
.el-table__body tr:hover {
  .icon_list_show {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #4E66FF;
  }
}


.com_page {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}



.el-dialog__wrapper /deep/.videoandimg {
  top: 0 !important;
  left: 0 !important;
  transform: none !important;
  border-radius: 0 !important;
  background: #000 !important;
}


/deep/ .el-carousel__container {
  height: 75vh !important;
  max-height: 75vh !important;

  .el-carousel__item {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;

    img {
      max-height: 100%;
    }
  }
}

.el-carousel__item:nth-child(2n) {
  background-color: #000000;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #000000;
}
/deep/ .el-carousel__arrow{
  background: #ccc !important;
}
</style>